<template>
  <v-container fluid style="padding-left: 300px">
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <v-form @submit.prevent="searchUserAuths">
          <v-card elevation="0" tile outlined>
            <v-card-text>
              <div class="mt-3">
                1.
                検索条件を入力してください。※名前とメールアドレスは部分一致での検索が可能です。
              </div>
              <v-layout align-center>
                <v-text-field
                  v-model="searchQuery.name_cont"
                  label="名前"
                  style="max-width: 200px"
                  clearable
                  class="mr-2"
                />
                <v-text-field
                  v-model="searchQuery.email_cont"
                  label="メールアドレス"
                  style="max-width: 300px"
                  clearable
                  class="mr-2"
                />
                <v-select
                  v-model="searchQuery.master_access_eq"
                  :items="selectableMasterAccesses"
                  item-text="type"
                  style="max-width: 150px"
                  class="mr-2"
                  item-value="value"
                  clearable
                  label="ユーザータイプ"
                />
                <select-site-list-container v-model="searchQuerySelectSites">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mr-4" v-bind="attrs" v-on="on" outlined>
                      サイト（{{ searchQuerySelectSites.length }}）
                    </v-btn>
                  </template>
                </select-site-list-container>
                <v-btn
                  color="primary"
                  dark
                  tile
                  outlined
                  small
                  type="submit"
                  @click="searchUserAuths"
                  @submit.prevent="searchUserAuths"
                >
                  検索
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12" lg="10" offset-lg="1">
        <div class='d-flex justify-space-between'>
          <MasterAdminPermissionGuardContainer>
            <v-btn
              color="success"
              class="mb-4"
              @click="invitationDialog = true"
            >
              新規ユーザー招待
            </v-btn>
          </MasterAdminPermissionGuardContainer>
          <div class="mb-4 ml-auto">
            <CsvDownloadContainer :query="searchQuery" />
          </div>
          <MasterAdminPermissionGuardContainer>
            <user-auth-invitation-dialog
              :invitation-dialog="invitationDialog"
              @close-dialog="invitationDialog = false"
              @invite-user-auth="inviteUserAuth"
            />
          </MasterAdminPermissionGuardContainer>
        </div>
        <h2 class="title mb-3">マスターユーザー一覧</h2>
        <UserAuthIndexTable
          :users="userAuths"
          @editUserAuth="editUserAuth"
          @update-users="searchUserAuths"
        />
        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="fetchAdminUsers"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。</v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。</v-chip>
          </template>
        </infinite-loading>

        <v-dialog v-model="editDialog" width="600">
          <UserAuthSitesForm
            :editing-user-auth="editingUserAuth"
            @updateEditingUserAuth="updateEditingUserAuth"
            @deleteEditingUserAuthSite="deleteEditingUserAuthSite"
            @updateEditingUserAuthUser="updateEditingUserAuthUser"
          />
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import headUtilsMixin from '@/mixins/head_utils'
import axios from 'axios'
import Qs from 'qs'
import { deserialize } from 'deserialize-json-api'
import UserAuthIndexTable from '@/components/commons/UserAuthIndexTable'
import UserAuthSitesForm from '@/components/commons/UserAuthSitesForm'
import UserAuthInvitationDialog from '@/components/commons/UserAuthInvitationDialog'
import MasterAdminPermissionGuardContainer from '/src/container/shared/MasterAdminPermissionGuardContainer'
import InfiniteLoading from 'vue-infinite-loading'
import CsvDownloadContainer from '../../../../src/container/pages/MasterAdmin/UserAuths/CsvDownloadContainer'
import SelectSiteListContainer from '../../../../src/container/pages/MasterAdmin/UserAuths/SelectSiteListContainer'

export default {
  components: {
    SelectSiteListContainer,
    CsvDownloadContainer,
    UserAuthIndexTable,
    UserAuthSitesForm,
    UserAuthInvitationDialog,
    InfiniteLoading,
    MasterAdminPermissionGuardContainer
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'マスターユーザー一覧',
      userAuths: [],
      page: 1,
      infiniteId: +new Date(),
      searchQuery: {
        master_access_not_eq: 0,
        master_access_eq: null,
        name_cont: '',
        email_cont: ''
      },
      searchQuerySelectSites: [],
      selectableMasterAccesses: [
        { type: '最高管理者', value: 1 },
        { type: '管理者', value: 4 },
        { type: 'ライター', value: 2 },
        { type: 'クライアント', value: 3 }
      ],
      editDialog: false,
      editingUserAuth: { name: null, sites: null },
      invitationDialog: false,
      userAuthDataLoading: true
    }
  },
  mounted: function () {
    // this.fetchAdminUsers()
  },
  methods: {
    fetchAdminUsers ($state) {
      axios
        .get('/api/master/user_auths', {
          params: {
            page: this.page,
            q: {
              ...this.searchQuery,
              map_user_auth_sites_site_id_in: this.searchQuerySelectSites.map(
                (site) => site.id
              )
            }
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(
          ({ data }) => {
            const fetchedUserAuths = deserialize(data).data

            if (fetchedUserAuths.length > 0) {
              this.page++
              this.userAuths = this.userAuths.concat(fetchedUserAuths)
              $state.loaded()
            } else {
              $state.complete()
            }
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    searchUserAuths () {
      this.page = 1
      this.userAuths = []
      this.infiniteId = +new Date()
    },
    editUserAuth (value) {
      this.editingUserAuth = value
      this.editDialog = true
    },
    updateEditingUserAuth (value) {
      this.editingUserAuth = value
      this.fetchAdminUsers()
    },
    deleteEditingUserAuthSite (value) {
      this.editingUserAuth.mapUserAuthSites =
        this.editingUserAuth.mapUserAuthSites.filter(
          (e) => !(e.site.id == value)
        )
      this.fetchAdminUsers()
    },
    updateEditingUserAuthUser (user, siteKey) {
      this.editingUserAuth.mapUserAuthSites.forEach(
        (mapUserAuthSite, index, array) => {
          if (mapUserAuthSite.site.siteKey == siteKey) {
            array[index].siteUser = user
          }
        }
      )
      this.fetchAdminUsers()
    },
    inviteUserAuth (masterAccess, email, siteKey) {
      const query = {
        masterAccess: masterAccess,
        email: email,
        siteKey: siteKey
      }
      this.$store.dispatch('LoaderStore/displayLoader')
      axios.post('/api/master/user_auths/invitations', query).then(
        (data) => {
          const deserializedData = deserialize(data).data
          this.fetchAdminUsers()
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: deserializedData.status,
            message: deserializedData.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
      this.invitationDialog = false
    }
  }
}
</script>

<style scoped></style>
